import * as React from 'react';
import ProviderAssetOrganizations from './ProviderAssetOrganizations';
import ProviderAssetSettings from './ProviderAssetSettings';
import ProviderAssetUsage from './ProviderAssetUsage';
import ProviderAssetData from './ProviderAssetData';
import TabNavigation from '../../shared/components/TabNavigation';
import Loading from '../../shared/components/loading/Loading';
import Typography from '@material-ui/core/Typography';
import BusinessIcon from '@material-ui/icons/Business';
import SettingsIcon from '@material-ui/icons/Settings';
import TimelineIcon from '@material-ui/icons/Timeline';
import LinkIcon from '@material-ui/icons/Link';
import HttpService from '../../../modules/core/services/HttpService';
import BreadCrumb from '../../shared/components/BreadCrumb';
import {identity} from '../../core/auth/identityAuth';
import { DataSharingTypeEnum } from "../../shared/constants";

const httpService = HttpService.Instance;

class ProviderAssetOverview extends React.Component<any, any> {
  public state: any = {
    asset: null,
    organizationSharingrules: [],
  };

  public async componentDidMount() {
    const assetResponse = await httpService.get(
      process.env.REACT_APP_API_URL +
        'assets/' +
        this.props.match.params.assetid
    );
    const asset = await assetResponse.json();
    this.setState({ asset });

    if (asset.dataSharing === DataSharingTypeEnum.SharingRules) {
      const organizationSharingruleResponse = await httpService.get(
        process.env.REACT_APP_API_URL +
          'entity/' +
          identity['nxt:entity:id'] +
          '/assets/' +
          this.props.match.params.assetid +
          '/providerorganizationsharingrules'
      );
      const organizationSharingrules = await organizationSharingruleResponse.json();
      this.setState({ organizationSharingrules });
    }
  }

  public render() {
    if (!this.state.asset) {
      return <Loading />;
    }
    
    const tabs = this.calculateTabs();

    return (
      <div>
        <Typography variant="title">{this.state.asset.name}</Typography>
        <Typography color="textSecondary" gutterBottom={true}>
          <BreadCrumb value="Console" to="/" />
          <BreadCrumb value="Provider" to="/providerassets" />
          Asset
        </Typography>
        <TabNavigation
          tabs={tabs}
          history={this.props.history}
          routeParm={this.props.match.params.tab}
        />
      </div>
    );
  }

  private calculateTabs() {
    const tabs = [];
    
    const generalTab = {
      icon: <SettingsIcon/>,
      label: 'GENERAL SETTINGS',
      page: {
        component: ProviderAssetSettings,
        routeAffix: 'settings',
        props: {assetId: this.props.match.params.assetid},
      },
    };
    tabs.push(generalTab);
    if (this.state.asset.dataSharing === DataSharingTypeEnum.SharingAgreements) {
      const dataTab = {
        icon: <LinkIcon/>,
        label: 'DATA',
        page: {
          component: ProviderAssetData,
          routeAffix: 'data',
          props: {
            assetId: this.props.match.params.assetid,
            asset: this.state.asset
          },
        },
      };
      tabs.push(dataTab);
    } else if (this.state.asset.dataSharing === DataSharingTypeEnum.SharingRules) {
      if (this.state.organizationSharingrules.length > 0) {
        const organizationAccessTab = {
          icon: <BusinessIcon/>,
          label: 'ORGANIZATION ACCESS',
          page: {
            component: ProviderAssetOrganizations,
            routeAffix: 'organizationacces',
            props: {
              assetId: this.props.match.params.assetid,
              organizationSharingrules: this.state.organizationSharingrules,
            },
          },
        };
        tabs.push(organizationAccessTab);
      }
    }
    const usageTab = {
      icon: <TimelineIcon/>,
      label: 'USAGE OVERVIEW',
      page: {
        component: ProviderAssetUsage,
        routeAffix: 'usage',
        props: {assetId: this.props.match.params.assetid},
      },
    };
    tabs.push(usageTab);
    return tabs;
  }
}

export default ProviderAssetOverview;



// WEBPACK FOOTER //
// ./src/modules/provider/pages/ProviderAssetOverview.tsx